import { Input } from "@rumbledirect/ui";
import { Form } from "antd";

export const AffiliateCreateDetailsStep = () => {
  return (
    <div>
      <>
        <Form.Item
          name="name"
          label="Naam"
          rules={[{ required: true, message: "Naam is verplicht" }]}
        >
          <Input placeholder="Bijv. Rumble Demo" />
        </Form.Item>
        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            { required: true, type: "email", message: "E-mail is verplicht" },
          ]}
        >
          <Input placeholder="demo@rumble.nl" />
        </Form.Item>
      </>
    </div>
  );
};
